import { render, staticRenderFns } from "./WechatBind.vue?vue&type=template&id=97587066&"
import script from "./WechatBind.vue?vue&type=script&lang=js&"
export * from "./WechatBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports